import { Injectable } from '@angular/core';

@Injectable()
export class ReportHelperService {

  constructor() { }

    public getScoreLevels(): Array<[number, string]> {
        var result: Array<[number, string]> = [];
        result.push([-2, "Ej signifikant"]);
        result.push([-1, "Ej tillämpligt"]);
        result.push([0, "Åtgärder krävs"]);
        result.push([1, "Godtagbar"]);
        result.push([2, "Bra"]);
        result.push([3, "Mycket bra"]);
        result.push([4, "Utmärkt"]);
        result.push([5, "Enastående"]);

        return result;
    }
}
